/*
 * Cleverroute
 * Cleverroute API
 *
 * OpenAPI spec version: 0.0.2
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.36
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {ResponseStatus} from './ResponseStatus';

/**
 * The ResponseAddUser model module.
 * @module model/ResponseAddUser
 * @version 0.0.2
 */
export class ResponseAddUser extends ResponseStatus {
  /**
   * Constructs a new <code>ResponseAddUser</code>.
   * @alias module:model/ResponseAddUser
   * @class
   * @extends module:model/ResponseStatus
   */
  constructor() {
    super();
  }

  /**
   * Constructs a <code>ResponseAddUser</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ResponseAddUser} obj Optional instance to populate.
   * @return {module:model/ResponseAddUser} The populated <code>ResponseAddUser</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ResponseAddUser();
      ResponseStatus.constructFromObject(data, obj);
      if (data.hasOwnProperty('userId'))
        obj.userId = ApiClient.convertToType(data['userId'], 'Number');
    }
    return obj;
  }
}

/**
 * user-id of the newly created user
 * @member {Number} userId
 */
ResponseAddUser.prototype.userId = undefined;

